<template>
    <div class="w-full">
        <RegisterContainer class="register__page" />
    </div>
</template>

<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex';

    import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
    import RegisterContainer from '@accountCountries/registration/RegisterContainer.vue';
    import { shellLocalConfig } from '@src/config/shell/localConfig';
    import { wafService } from '@core/services/waf/WafService';
    import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

    export default {
        name: 'RegisterPage',
        mounted() {
            wafService.maybeLoadWafScript();
            if (shellLocalConfig.seonConfig.register.isServiceEnabled) {
                antiFraudService.initialize(this.config.antiFraud);
            }

            const { screenName, modalName } = this.$route.params;

            this.isScreenOpenAccountOpenSent = shellLocalConfig.isScreenOpenAccountOpenSent;
            if (this.isScreenOpenAccountOpenSent) {
                AnalyticsSDK.getInstance().log('account_open', {
                    screen_name: screenName,
                    modal_name: modalName,
                });
            }
        },
        computed: {
            ...mapGetters('data/country', [
                'config',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'addAfterCloseHook',
            ]),
        },
        components: {
            RegisterContainer,
        },
    };
</script>
